import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import {  tapResponse } from '@ngrx/operators';
import { BehaviorSubject, Observable, mergeMap, pipe, switchMap } from 'rxjs';
import { WorkshopJobTemplate } from 'src/app/models/workshop-job-template';
import { WorkshopJobTemplateService } from 'src/app/shared/services/workshop-job-template.service';

interface TemplateListState {
  templates: WorkshopJobTemplate[];
  fetching: boolean;
}

const initialState: TemplateListState = {
  templates: [],
  fetching: false
};

@Injectable()
export class TemplateStoreService extends ComponentStore<TemplateListState> {
  templates$ = this.select((state) => state.templates);
  initialLoad$ = this.select(
    (state) => state.templates.length === 0 && state.fetching
  );

  refetch = new BehaviorSubject<void>(null);

  constructor(private templateService: WorkshopJobTemplateService) {
    super(initialState);
  }

  getTemplates = this.effect((source: Observable<void>) =>
    source.pipe(
      switchMap(() => {
        this.patchState({ fetching: true });
        return this.templateService.getAll().pipe(
          tapResponse(
            (templates: any[]) => {
              this.patchState({ templates, fetching: false });
            },
            (error) => console.error(error)
          )
        );
      })
    )
  );
}
